// extracted by mini-css-extract-plugin
export default {"controls":"CustomControls_controls__oNVFx"};